// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Header-cls1__a78b3da21489419d64be{/*!*/}.Header-cls2__e17ea32ea636f5108b27{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;color:#535366}.Header-cls2__e17ea32ea636f5108b27>*:not(:first-child)::before{content:\"•\";padding:0 6px;color:#535366}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "Header-cls1__a78b3da21489419d64be",
	"cls2": "Header-cls2__e17ea32ea636f5108b27 Header-cls1__a78b3da21489419d64be"
};
export default ___CSS_LOADER_EXPORT___;
